<template>
  <div class="footer">
    <div class="footer-box">
      <div class="logo-box">
        <div class="logo-name">
          <img src="../assets/logo.png" class="logo-1" />
          <p>PT LAYAR CERITA IMAJINASI</p>
        </div>
        <div class="text">
          GRAND SLIPI TOWER LANTAI 5 UNIT F, JALAN S PARMAN KAVLING
          22-24, Desa/Kelurahan Palmerah, Kec. Pal Merah, Kota Adm. Jakarta
          Barat, Provinsi DKI Jakarta,

        </div>
      </div>
      <div class="connect">
        <p><img src="../assets/tel.png" alt="" /> 82311612927</p>
        <p><img src="../assets/email.png" alt="" />  layarceritapt@gmail.com</p>
      </div>
    </div>

    <!-- <div class="copyright">
      © 2024 Speedy Loan All rights reserved.

    </div> -->
  </div>
</template>
<style lang="less" scoped>
  .footer {
    .footer-box {
      height: 176px;
      background: #FEFBF6;
      padding:  50px 360px;
      display: flex;
      justify-content: space-between;
      align-items:center;
      .logo-box {
        width: 500px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;

        .logo-name {
          display: flex;
          align-items: center;
          justify-content: flex-start;

          .logo-1 {
            width: 38px;
            height: 38px;
            margin-right: 14px;
          }

          p {
            font-family: Paytone One, Paytone One;
            font-weight: 400;
            font-size: 28px;
            color: #333333;
          }
        }

        .text {
          font-family: Roboto, Roboto;
          font-weight: 400;
          font-size: 20px;
          color: rgba(51, 51, 51, 0.8);
          margin-top: 20px;
        }
      }

      .connect {
        font-family: Roboto, Roboto;
        font-weight: 400;
        font-size: 20px;
        color: #333333;

        p:first-child {
          margin-bottom: 30px;
        }

        p {
          img {
            width: 30px;
            vertical-align: middle;
            margin-right: 10px;
          }
        }
      }
    }

    .copyright {
      height: 76px;
      background: #000;
      font-family: Roboto, Roboto;
      font-weight: 400;
      font-size: 16px;
      color: #ffffff;
      line-height: 76px;
      text-align: center;
    }
  }
</style>
<script>
  export default {
    data() {
      return {};
    },
    methods: {
      send() {
        alert("send success");
      },
      selectMenu(value) {
        this.index = value;
        if (value == this.step) {
          return;
        }
        switch (value) {
          case 1:
            this.$router.push({ path: "/" });
            break;
          case 2:
            this.$router.push({ path: "about" });
            break;
          case 3:
            this.$router.push({ path: "services" });
            break;
          case 4:
            this.$router.push({ path: "offers" });
            break;
          case 5:
            this.$router.push({ path: "contact" });
            break;
          // case 5: this.$router.push({ path: "cooperate" }); break;
          default:
            this.$router.push({ path: "/" });
            break;
        }
      },
    },
  };
</script>